export var IMPRESSION_REPORTED = 'IMPRESSION_REPORTED';
export * from '../shared/actions/impressions';
export var impressionReported = function impressionReported(elementId, eventData) {
  return {
    type: 'IMPRESSION_REPORTED',
    elementId: elementId,
    eventData: eventData
  };
};